import React from 'react';
import './slideshow.css';
import { Link } from "gatsby";

const SlideShow = () => {
  return (
    <div id="slider">
      <ul>
        <li>
          <span></span>
          <div id="firstText" className="fontFour">
            <h1 className="mansysco-logo-header">ManSysCo Pty Ltd.<br /></h1>
            <p>Delivering outcomes not just outputs</p>
          </div>
        </li>
        <li>
          <span></span>
          <div id="secondText" className="fontFour ">
            <h1 className="fontFive">Our capabilities<br /></h1>
            <p>
              we are uniquely positioned <br />
              to tackle more complex<br />
              and challenging engineering/R&D projects.
            </p>
          </div>
        </li>
        <li>
          <span></span>
          <div id="thirdText" className="fontFour">
            <h1 className="fontFive">Reliablity<br /></h1>
            <p>
              We are passionate about our services, <br />
              and want to utilise them for<br />
              your benefit.
            </p>
            <button id="contactBtn">
              <Link to="/#contact">
                Contact us
              </Link>
            </button>
          </div>
        </li>
      </ul>
    </div>
  )
}

export default SlideShow;